module.exports = __webpack_public_path__ + "static/Corona-Modelo-Lunch-Truck-Action-SoCal-9-2-19-ce4669b87a3a916be43f32601abb9dad.jpg";